var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrownAlgae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,88 C44,90 40,92 36,94 M50,88 C50,91 50,93 50,95 M50,88 C56,90 60,92 64,94 M50,88 C47,91 45,93 43,95 M50,88 C53,91 55,93 57,95",
    fill: "none",
    stroke: "#5E4A24",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,90 C48,78 52,66 50,54",
    fill: "none",
    stroke: "#8A6D3B",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,40 Q30,24 26,15",
    fill: "none",
    stroke: "#8A6D3B",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,40 Q41,24 39,9",
    fill: "none",
    stroke: "#8A6D3B",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,40 Q50,24 50,6",
    fill: "none",
    stroke: "#8A6D3B",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,40 Q59,24 61,9",
    fill: "none",
    stroke: "#8A6D3B",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,40 Q70,24 74,15",
    fill: "none",
    stroke: "#8A6D3B",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 46,
    r: 9.5,
    fill: "#A5854A",
    stroke: "#5E4A24",
    strokeWidth: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownAlgae);
export default __webpack_public_path__ + "static/media/brown_algae.e6bf3a4e5a4fc650a1c31b417f58b096.svg";
export { ForwardRef as ReactComponent };